export const XBIT_RELAY_WITHDRAWAL_PROVIDER_CONFIGS_PERMISSION_RESOURCE =
  'xbit-relay:withdrawal-provider-configs';

export const CHAIN_NAME_BY_ID: Record<string, string> = {
  '1': 'eth',
  '56': 'bsc',
  '137': 'pol',
  '8453': 'base',
  '42161': 'arb',
  '728126428': 'tron',
};

// Fixed order used by the fees table; row index maps to this list.
export const CHAIN_IDS = Object.keys(CHAIN_NAME_BY_ID);
